import React, { useRef, useEffect } from "react";
import { Form } from "react-bootstrap";

/**
 * Google Places Autocomplete input
 * Props:
 *  - label: input label
 *  - onPlaceSelected(place): callback with selected PlaceResult
 *  - required: boolean
 */
export default function AddressAutocomplete({
  label,
  onPlaceSelected,
  required = false,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    function initAutocomplete() {
      if (!inputRef.current || !window.google || !window.google.maps) return;
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ["geocode"],
        }
      );
      autocomplete.setFields(["address_components", "formatted_address"]);
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        onPlaceSelected(place);
      });
    }

    if (!window.google || !window.google.maps) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places`;
      script.async = true;
      script.onload = initAutocomplete;
      document.body.appendChild(script);
    } else {
      initAutocomplete();
    }
  }, [onPlaceSelected]);

  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        ref={inputRef}
        type="text"
        placeholder={`Enter ${label}`}
        required={required}
      />
    </Form.Group>
  );
}
